module.exports = __webpack_public_path__ + "img/29.67114c3b.png";